import { render } from "./BaseTypePageCap.vue?vue&type=template&id=1d2640d6"
import script from "./BaseTypePageCap.vue?vue&type=script&lang=js"
export * from "./BaseTypePageCap.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__